import { render, staticRenderFns } from "./VerifactuFinancialDashboard.vue?vue&type=template&id=50efa4f4"
import script from "./VerifactuFinancialDashboard.vue?vue&type=script&lang=js"
export * from "./VerifactuFinancialDashboard.vue?vue&type=script&lang=js"
import style0 from "./VerifactuFinancialDashboard.vue?vue&type=style&index=0&id=50efa4f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports